import { render } from "./RestaurantList.vue?vue&type=template&id=9d50b74c"
import script from "./RestaurantList.vue?vue&type=script&lang=js"
export * from "./RestaurantList.vue?vue&type=script&lang=js"

import "@/css/booking/booking.css?vue&type=style&index=0&lang=css&external"
import "./RestaurantList.vue?vue&type=style&index=1&id=9d50b74c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__